module.exports = __webpack_public_path__ + "img/sort-alpha-down-alt.a72ebd69.svg";